import styled from "styled-components";
import FetchAbsenceReplacement from "./FetchAbsenceReplacement";
import AddAbsenceReplacement from "./AddAbsenceReplacement";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 25px;

  @media (max-width: 900px) {
    padding: 15px;
  }
`;

export default function AbsenceReplacementPopup({
  userID,
  date,
  callback,
  mode = "absence",
  vacantSlot,
  onBeforeAssign,
}) {
  return (
    <Container>
      <FetchAbsenceReplacement
        userID={userID}
        date={date}
        mode={mode}
        vacantSlot={vacantSlot}
        callback={callback}
      />
      <AddAbsenceReplacement
        userID={userID}
        date={date}
        mode={mode}
        vacantSlot={vacantSlot}
        onBeforeAssign={onBeforeAssign}
        callback={callback}
      />
    </Container>
  );
}
